import styled from "styled-components"

import IconExternalLink from "../../../../../../src/assets/external_link.svg"
import {
  TextLink,
  Body,
} from "../../../../../component-library/design/typography/typography.styles"
import { FONT_WEIGHT } from "../../../../../component-library/design/typography/typography.constants"
import { SPACING } from "../../../../../component-library/design/spacing/spacing.constants"
import { COLOR } from "../../../../../component-library/design/color/color.constants"

const StyledExternalLinkIcon = styled(IconExternalLink)`
  margin-left: ${SPACING.XS};
`

const StyledTextLink = styled(TextLink)`
  font-weight: ${FONT_WEIGHT.REGULAR};
  display: inline-block;
`

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`

const ErrorText = styled(Body)`
  margin-top: ${SPACING.XS};
  color: ${COLOR.RED_MEDIUM};
`

export { StyledExternalLinkIcon, StyledTextLink, FlexContainer, ErrorText }
